'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-layout__full-width {\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box; }\n  .varta-layout__full-width main {\n    padding: 60px 0 0;\n    margin: 0 auto;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden; }\n  .varta-layout__full-width__wrapper {\n    max-width: 960px;\n    margin: 0 auto;\n    padding: 0 20px; }\n";
styleInject_es(css_248z);
